import { KeyValueModel } from "model/api";
import { EnumTipoAvaliacaoDesempenho } from "model/enums/enum-tipo-avaliacao-desempenho";

export const TipoAvaliacaoDesempenhoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoAvaliacaoDesempenho.NaoAvalia, "Não Avalia"),
    new KeyValueModel(EnumTipoAvaliacaoDesempenho.Avalia, "Avalia"),
];